export const PATTERN_EMAIL_VALIDATION =
  /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@([^\s@]{2,}\.[^<>()[\]\.,;:\s@\"]{2,})$/i;
export const PATTERN_PHONE_VALIDATION = /^[\d]{7,15}$/;
export const PATTERN_POSITION_VALIDATION = /^[\d]{1,140}$/;
export const PATTERN_EMAIL_LENGTH_VALIDATION = /^.{6,60}$/;
export const PATTERN_PHONE_VALIDATION_MAX_16 = /^[\d]{7,16}$/;
export const PATTERN_PASSWORD_VALIDATION_NO_SPACE = /^[^\s]*$/;
export const PATTERN_PASSWORD_VALIDATION_LETTER_EXPECTED = /^(?=.*[a-zA-Z])/;
export const PATTERN_PASSWORD_VALIDATION_LETTER_UPPERCASE_EXPECTED =
  /^(?=.*[A-Z])/;
export const PATTERN_PASSWORD_VALIDATION_NUMBER_EXPECTED = /^(?=.*\d)/;
export const PATTERN_SEARCH_FIELD_ID = /^[\d]{1,3}$/;
export const PATTERN_NUMBERS_ONLY = /^[0-9]+$/;
export const AMOUNT_VALIDATION_EXPECTED = /^[0-9]+([.,][0-9]+)?$/;
export const ONLY_TWO_DIGITS_AFTER_COMMA_EXPECTED = /^[0-9]+([.,][0-9]{1,2})?$/;
